import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as S from './style';
import infoBanner from '@/assets/img/banner/news.png';
import shareIcon from '@/assets/img/icon/shareIcon.svg';
import LineIcon from '@/components/Icon/lineIcon';
import SingleArrowPrev from '@/components/Icon/SingleArrowPrev';
import SingleArrowNext from '@/components/Icon/SingleArrowNext';
import { useState } from 'react';
import ModalShare from '@/components/common/Modal/ModalShare/ModalShare';
import ModalPortal from '@/components/common/Modal/ModalPortal/ModalPortal';
import { FileDetal, InfoDetailResType, useGetInfoDetailApi } from '@/api/notice';
import { convertInfoValue } from '@/utils/convertValue';
import dayjs from 'dayjs';
import DownloadIcon from '@/components/Icon/DownloadIcon';
import { downloadFile } from '@/utils/fileUtils';
import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';

const InfoPlaceDetail = () => {
	const params = useParams();
	const location = useLocation();
	const navigate = useNavigate();
	const { id } = params;
	const paramsMenu = location.state?.menu ?? '소식지';
	const [isOpenShare, setIsOpenShare] = useState(false);

	const { data: infoDetailData } = useGetInfoDetailApi({
		info_pk: id ?? '',
		type: 'newsletter',
	});
	const handleOpenModalShare = (bool: boolean) => {
		setIsOpenShare(bool);
	};
	const getDynamicField = (g: any, field: string) => {
		const type = 'newsletter';
		return g[`${type}_${field}`] || ''; // 동적으로 필드 처리
	};
	const getDynamicFieldFile = (data: InfoDetailResType | undefined, field: string): FileDetal[] | undefined => {
		const type = 'newsletter'; // 예: 'notice'
		const key = `${type}_${field}` as keyof InfoDetailResType;
		const value = data?.[key];
		return Array.isArray(value) ? value : undefined;
	};
	const formatBytesToKB = (bytes: number) => `${Math.round(bytes / 1024)} KB`;
	return (
		<>
			<main>
				<SubBanner subTitle="News" title="회사의 주요 활동과 투자 관련 최신 소식을 공유합니다." img={infoBanner} />
				<S.ConferenceContainer>
					<S.ConferenceHeader>
						<S.ConferenceTitlebox>
							<S.ConferenceTitle>{getDynamicField((infoDetailData && infoDetailData['newsletter']) ?? '', 'title') ?? ''}</S.ConferenceTitle>
							<S.ConferenceSubTitle>
								{dayjs(getDynamicField((infoDetailData && infoDetailData['newsletter']) ?? '', 'enrollment_date')).format('YYYY-MM-DD') ?? ''}
								<LineIcon />
								조회수:{' '}
								{getDynamicField((infoDetailData && infoDetailData['newsletter']) ?? '', 'hit')
									? getDynamicField((infoDetailData && infoDetailData['newsletter']) ?? '', 'hit')
									: '0'}
								<LineIcon />
								작성자: {infoDetailData && infoDetailData['newsletter']?.admin_name}
							</S.ConferenceSubTitle>
						</S.ConferenceTitlebox>
						<div className="share_icon">
							<S.ImgBox onClick={() => setIsOpenShare(!isOpenShare)}>
								<img src={shareIcon} alt="share" />
							</S.ImgBox>
						</div>
					</S.ConferenceHeader>
					<S.ContentBox>
						<S.Content
							dangerouslySetInnerHTML={{ __html: getDynamicField((infoDetailData && infoDetailData['newsletter']) ?? '', 'content') ?? '' }}
						/>
						<S.DownLoadBoxList>
							{infoDetailData &&
								getDynamicFieldFile(infoDetailData, 'file')?.map((item, index) => (
									<S.DownLoadBox key={index} onClick={() => downloadFile(item.file_path ?? '', item.file_pk ?? '')}>
										<S.DownLoadContent>
											<div className="title">{item.file_original_name ?? ''}</div>
											<div className="sub_title">{formatBytesToKB(item.file_size ?? 0)}</div>
										</S.DownLoadContent>
										<DownloadIcon iconColor="#ADB5BD" width="20" height="20" />
									</S.DownLoadBox>
								))}
						</S.DownLoadBoxList>
						<S.MenuBox>
							<S.MenuList>
								{!infoDetailData?.prev_pk ? (
									<></>
								) : (
									<S.Menu type="button" onClick={() => navigate(`/infoplace/detail/${infoDetailData?.prev_pk}`, { state: { menu: paramsMenu } })}>
										<SingleArrowPrev iconColor="#212529" width="18" height="18" /> 이전글
									</S.Menu>
								)}{' '}
								{!infoDetailData?.next_pk ? (
									<></>
								) : (
									<S.Menu type="button" onClick={() => navigate(`/infoplace/detail/${infoDetailData?.next_pk}`, { state: { menu: paramsMenu } })}>
										다음글
										<SingleArrowNext iconColor="#212529" width="18" height="18" />
									</S.Menu>
								)}
							</S.MenuList>
							<S.MenuList>
								<S.MenuActive type="button" onClick={() => navigate('/infoplace', { state: { menu: paramsMenu } })}>
									목록
								</S.MenuActive>
							</S.MenuList>
						</S.MenuBox>
					</S.ContentBox>
				</S.ConferenceContainer>
			</main>
			{isOpenShare && (
				<ModalPortal>
					<ModalShare onClick={handleOpenModalShare} />
				</ModalPortal>
			)}
		</>
	);
};
export default InfoPlaceDetail;
